export default (theme) => ({
  name: {
    fontSize: '30px',
    fontWeight: 500,
    paddingRight: 20,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  avatarContainer: {
    textAlign: 'center'
  },
  avatar: {
    display: 'inline-block'
  },
  textContainer: {
    display: 'inline-block',
    verticalAlign: 'top',
    marginLeft: 30
  },
  subheader: {
    marginTop: 5,
    fontSize: '18px',
    paddingRight: 20
  },
  addressPart: {
    marginTop: 0
  },
  divider: {
    marginTop: 20
  },
  description: {
    marginTop: 20,
  },
  cardContent: {
    position: 'relative',
    padding: 20
  },
  resultsButton: {
    position: 'absolute',
    right: 16,
    top: 16
  },
});
